import { customAlphabet } from "nanoid";

const alphabet =
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
export const mkid = customAlphabet(alphabet, 22);
// id() //=> "CoGWxtp4ycZmqP7THTOYIS"
